import * as React from 'react';
import { SelectRangeContext } from './SelectRangeContext';
/** Hook to access the [[SelectRangeContext]]. */
export function useSelectRange() {
    var context = React.useContext(SelectRangeContext);
    if (!context) {
        throw new Error('useSelectRange must be used within a SelectRangeProvider');
    }
    return context;
}
//# sourceMappingURL=useSelectRange.js.map